import React from 'react';
import { Input, InputProps } from '@amzn/awsui-components-react-v3';
import { NonCancelableEventHandler } from '@amzn/awsui-components-react-v3/polaris/internal/events';

const RefScanInput = React.forwardRef(
  (
    {
      value,
      placeholder,
      onScan,
      onInput,
      clearOnEnter,
      disabled,
      onBlur,
      autoFocus,
      className,
    }: {
      value: string;
      placeholder?: string;
      onScan: (input: string) => void;
      onInput?: NonCancelableEventHandler<InputProps.ChangeDetail>;
      clearOnEnter?: boolean;
      disabled?: boolean;
      onBlur?: NonCancelableEventHandler<null> | undefined;
      autoFocus?: boolean;
      className?: string;
    },
    ref: React.Ref<InputProps.Ref>
  ) => {
    const handleScanComplete = (event: CustomEvent<InputProps.KeyDetail>): void => {
      if (event.detail.key === 'Enter' && value?.trim() !== '') {
        onScan(value.trim());
      }
    };

    return (
      <Input
        className={className}
        ref={ref}
        value={value}
        placeholder={placeholder}
        onChange={onInput}
        onKeyDown={handleScanComplete}
        data-testid="barcode-scan"
        disabled={disabled}
        onBlur={onBlur}
        autoFocus={autoFocus}
      />
    );
  }
);

export default RefScanInput;
